export default "__VITE_ASSET__BiJN1ZyP__"